export default __webpack_public_path__ + "static/fall10-46c4ea5c614d8aaca8d7850bb5926d0d.webp";